import * as React from "react";
import { forwardRef } from "react";
const SvgPendingIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24, fill: "currentColor", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10            10-4.48 10-10S17.52 2 12 2Zm0 18            c-4.41 0-8-3.59-8-8s3.59-8 8-8            8 3.59 8 8-3.59 8-8 8Z" }), /* @__PURE__ */ React.createElement("path", { d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67V7Z" }));
const ForwardRef = forwardRef(SvgPendingIcon);
export { ForwardRef as ReactComponent };
